import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";

import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";

import { WizardRegionHotwireContentProps } from "../typings";
import { DesktopHeading } from "./DesktopHeading";
import { DesktopHeroAttribution } from "./DesktopHeroAttribution";
import { cropResizeSrc } from "src/components/shared/BlossomImage/BlossomImage";
import { useMultiLOBWizardRegion } from "./../WizardRegionContextProvider/MultiLOBWizardRegionContext";

export const DesktopContent = observer(
  ({ lineOfBusiness, model, destinationHero, wizard }: WizardRegionHotwireContentProps) => {
    const { wizardState } = React.useContext(MobXProviderContext);

    // Override the desktop background image from the model if there is no destination-hero on the page
    if (model.backgroundImage && !destinationHero) {
      wizardState.globalWizardState.config.heroImageSrc = model.backgroundImage;
    }

    const backgroundImageSrc = cropResizeSrc(
      wizardState.globalWizardState.config.heroImageSrc,
      { width: 1176, height: 504 },
      "medium"
    );

    const { backgroundColor } = model;
    const backgroundImageGradient = "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(23, 26, 35, 0.5) 100%)";
    const backgroundImage = `${backgroundImageGradient}, url("${backgroundImageSrc}")`;
    const { isMultiLOB } = useMultiLOBWizardRegion();
    const isPackages = lineOfBusiness === "package";

    return (
      <UitkLayoutFlex
        className={`WizardRegionHotwire WizardRegionHotwire--${isMultiLOB ? "MultiLob" : "SingleLob"}`}
        data-testid="wizard-region-hotwire"
        direction="column"
        data-module={`farefinder-${lineOfBusiness}`}
      >
        <div
          className={`WizardRegionHotwire--Background ${isPackages ? "packages" : ""}`}
          style={{ backgroundColor, backgroundImage }}
        />
        <UitkSpacing padding="twelve">
          <UitkLayoutFlex className="WizardRegionHotwire--Content" direction="column" justifyContent="center">
            <UitkSpacing margin={{ blockend: "three" }}>
              <UitkLayoutFlexItem>
                <div className="WizardRegionHotwire--Heading">
                  <DesktopHeading title={model.title} innerTitle={model.innerTitle} />
                </div>
              </UitkLayoutFlexItem>
            </UitkSpacing>
            <UitkLayoutFlexItem>{wizard}</UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkSpacing>
        {destinationHero && <DesktopHeroAttribution destinationHero={destinationHero} />}
      </UitkLayoutFlex>
    );
  }
);
